import { render, staticRenderFns } from "./payLadderComponent.vue?vue&type=template&id=40987d73&scoped=true"
import script from "./payLadderComponent.vue?vue&type=script&lang=js"
export * from "./payLadderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40987d73",
  null
  
)

export default component.exports